export const TIME_REPORT_FILTER_FORM_UPDATE_DATE_RANGE = "TIME_REPORT_FILTER_FORM_UPDATE_DATE_RANGE";
export const TIME_REPORT_FILTER_FORM_UPDATE_ONLY_ERRORS = "TIME_REPORT_FILTER_FORM_UPDATE_ONLY_ERRORS";
export const TIME_REPORT_FILTER_FORM_UPDATE_DEFAULT = "TIME_REPORT_FILTER_FORM_UPDATE_DEFAULT";
export const TIME_REPORT_FILTER_FORM_SUBMIT = "TIME_REPORT_FILTER_FORM_SUBMIT";
export const TIME_REPORT_FILTER_FORM_SUBMIT_SUCCESS = "TIME_REPORT_FILTER_FORM_SUBMIT_SUCCESS";